import ApiService from './api';
import api from '../hooks/useHttp';

class UserService extends ApiService {
  constructor() {
    super('/api/users');
  }

  // Get all users with pagination and filters
  async getUsers(params = {}) {
    return await this.get('', params);
  }

  // Get user by ID
  async getUserById(id) {
    return await this.get(`/${id}`);
  }

  // Search users with advanced filters
  async searchUsers(query, filters = {}) {
    return await this.get('/search', { q: query, ...filters });
  }

  // Get users by role
  async getUsersByRole(role, params = {}) {
    return await this.get(`/role/${role}`, params);
  }

  // Get current user profile (requires authentication)
  async getCurrentUserProfile() {
    return await this.get('/profile');
  }

  // Create new user (supports FormData for file uploads)
  async createUser(userData) {
    return await this.create(userData);
  }

  // Update user (supports FormData for file uploads)
  async updateUser(id, userData) {
    return await this.update(id, userData);
  }

  // Update user status
  async updateUserStatus(id, status) {
    return await api.put(`${this.baseUrl}/${id}/status`, { status });
  }

  // Update current user profile (requires authentication, supports FormData)
  async updateCurrentUserProfile(id, userData) {
    return await api.put(`${this.baseUrl}/profile/${id}`, userData);
  }

  // Delete user
  async deleteUser(id) {
    return await this.delete(id);
  }

  // Delete user file (PDF document)
  async deleteUserFile(id) {
    return await api.delete(`${this.baseUrl}/${id}/file`);
  }

  // Get customers from allowedCustomers of THIS specific user
  async getAllowedCustomers(userId) {
    return await this.get(`/${userId}/allowedCustomers`);
  }
}

export default new UserService();

